
import { Component, ElementRef } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { Subscription } from '../../../node_modules/rxjs';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppStore } from '../../store/AppStore';

import { EvaluationService } from '../../services/evaluation-service';

import { AppliedEvaluation } from '../../model/avalicorp/AppliedEvaluationModel';

import { AppliedEvaluationStatus } from '../../services/applied-evaluation-status-constant';
import { LoginPage } from '../login/login';
import { RealizeEvaluationPage } from '../avalicorp-realize-evaluation/realize-evaluation';

@IonicPage()
@Component({
  selector: 'page-evaluations',
  templateUrl: 'evaluations.html'
})

export class EvaluationsPage {

  public myEvaluations: {};
  public filteredItems: Array<AppliedEvaluation> = [];
  public selectedType: string = "evaluated";
  public appliedEvaluationStatus: any = AppliedEvaluationStatus;

  private userSubscription: Subscription;

  private userId: number;

  constructor(
    public navCtrl: NavController,
    public element: ElementRef,
    private store: Store<AppStore>,
    private evaluationService: EvaluationService
  ) {

  }

  ionViewWillEnter() {
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.user != null) {
        this.userId = userState.user ? userState.user.id : null;
        this.getMyEvaluations(this.userId);
      }
    });
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
  }

  logoff() {
    this.navCtrl.setRoot(LoginPage);
  }

  private getMyEvaluations(userId: number) {
    this.evaluationService.listByUserId(userId)
      .subscribe(data => {
        data = this.convertUserProccess(data);
        this.setMyEvaluation(data);
      });
  }

  private setMyEvaluation(appliedEvaluation = []) {
    this.myEvaluations = {
      evaluated: this.evaluationService.getByEvaluated(appliedEvaluation, this.userId),
      evaluator: this.evaluationService.getByEvaluator(appliedEvaluation),
      supervisor: this.evaluationService.getBySupervisor(appliedEvaluation)
    }
    this.changeList();
  }

  changeList() {
    this.filteredItems = this.myEvaluations[this.selectedType];
  }

  checkToRealize(appliedEvaluation: AppliedEvaluation) {
    if (appliedEvaluation.status != AppliedEvaluationStatus.NAO_INICIADO) {
      this.realize(appliedEvaluation)
      return;
    }

    appliedEvaluation.status = AppliedEvaluationStatus.EM_ANDAMENTO;
    appliedEvaluation.usersProcess[appliedEvaluation.type].status = AppliedEvaluationStatus.EM_ANDAMENTO;
    this.evaluationService.save(appliedEvaluation).subscribe(() => {
      this.realize(appliedEvaluation)
    });
  }

  private realize(appliedEvaluation: AppliedEvaluation) {
    this.navCtrl.push(RealizeEvaluationPage, { appliedEvaluation: appliedEvaluation, userId: this.userId });
  }

  getIndicatorLabel(performance: any): any {
    return {
      "Alto": { color: 'secondary' },
      "Medio": { color: 'warning' },
      "Baixo": { color: 'danger' }
    }[performance]
  }

  private convertUserProccess(data: any): Array<AppliedEvaluation> {
    return data.filter(function (evaluation) {
      evaluation["usersProcess"] = JSON.parse(evaluation["usersProcess"]);
      return evaluation;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/avalicorp/evaluations.ts